/* eslint-disable max-len */
import React from "react"

const FlexiPointsFilled = (props) => {
  return (
    <svg {...props} width="24" height="26" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10.5" fill="#21295C" />
      <path
        d="M12.3772 6.71664L13.3591 9.65357C13.422 9.84261 13.6033 9.97052 13.8077 9.97052H16.9844C17.4416 9.97052 17.6316 10.539 17.2619 10.8001L14.6916 12.6153C14.5265 12.732 14.4573 12.939 14.5202 13.128L15.502 16.0649C15.6432 16.4874 15.1458 16.8388 14.7761 16.5777L12.2058 14.7625C12.0405 14.6457 11.8166 14.6457 11.6515 14.7625L9.08124 16.5777C8.71149 16.8388 8.21407 16.4874 8.3552 16.0649L9.33681 13.128C9.40002 12.939 9.33083 12.732 9.16541 12.6153L6.59541 10.8001C6.22565 10.539 6.41569 9.97052 6.87277 9.97052H10.0494C10.2537 9.97052 10.435 9.84261 10.4982 9.65357L11.4798 6.71664C11.6212 6.29432 12.2361 6.29432 12.3772 6.71664Z"
        fill="white"
      />
    </svg>
  )
}

export default FlexiPointsFilled
